import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import TutorialBanner from '../components/tutorial/ui/TutorialBanner';
import EmployeeManagement from './EmployeeManagement';

const ResponsiveEmployeeManagement = () => {
  const isCompactTutorial = useMediaQuery('(max-width:960px)');
  const location = useLocation();
  const fromTutorial = Boolean(location.state?.fromTutorial);

  return (
    <Box sx={{ backgroundColor: 'transparent' }}>
      {fromTutorial && (
        <div style={{ padding: isCompactTutorial ? '8px' : '16px' }}>
          <TutorialBanner
            description="Invite team members and assign roles so they can access the app and appear on the schedule."
            onDismiss={() => {}}
          />
        </div>
      )}
      <EmployeeManagement />
    </Box>
  );
};

export default ResponsiveEmployeeManagement;
